import { AthleteProfileSummary } from "@/components/health/AthleteProfileSummary";
import { WeightTrendChart } from "@/components/health/WeightTrendChart";
import { BodyMeasurementHistory } from "@/components/health/BodyMeasurementHistory";
import { EnergyBalanceChart } from "@/components/health/EnergyBalanceChart";

export function HealthBody() {
  return (
    <article aria-labelledby="body-heading">
      <p
        style={{
          fontFamily: "var(--font-sans)",
          fontSize: "var(--type-micro)",
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "var(--fg-3)",
          margin: 0,
        }}
      >
        Health · Body
      </p>
      <h1
        id="body-heading"
        style={{
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
          fontWeight: 500,
          fontSize: "var(--type-display-m)",
          margin: "var(--space-2) 0 var(--space-8)",
        }}
      >
        Where you stand.
      </h1>

      <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-6)" }}>
        <AthleteProfileSummary />
        <WeightTrendChart />
        <EnergyBalanceChart />
        <BodyMeasurementHistory />
      </div>
    </article>
  );
}
